module.exports = __webpack_public_path__ + "img/fast.d919d3b5.svg";